export default "__VITE_ASSET__BMWXXuaI__"